// extracted by mini-css-extract-plugin
export default {"root":"Start-module_root-qsf5O"};